/* @flow */
import AdminTeacherTypeahead from './AdminTeacherTypeahead';

export default AdminTeacherTypeahead;
